import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { MinesBomb, MinesDiamond } from '../originals/MinesArtwork';
import './adminMinesBoard.css';

export const AdminMinesBoardDialog = ({ selected, onClose, triggerRef }) => {
  const bombs = new Set(selected?.row.outcome?.bomb_set || []);
  return <Dialog open={Boolean(selected)} onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className="admin-mines-board-dialog" data-testid="admin-mines-board-dialog" onCloseAutoFocus={(event) => { event.preventDefault(); triggerRef.current?.focus(); }}>
      <DialogHeader>
        <DialogTitle data-testid="admin-mines-board-title">Mines · Bet {(selected?.index ?? 0) + 1}</DialogTitle>
        <DialogDescription data-testid="admin-mines-board-nonce">Nonce {selected?.row.nonce} · Read-only preview</DialogDescription>
      </DialogHeader>
      <div className="admin-mines-board-legend" data-testid="admin-mines-board-legend">
        <span data-testid="admin-mines-diamond-count"><MinesDiamond />{25 - bombs.size} diamonds</span>
        <span data-testid="admin-mines-bomb-count"><MinesBomb />{bombs.size} {bombs.size === 1 ? 'mine' : 'mines'}</span>
      </div>
      <div className="admin-mines-numbered-board" role="group" aria-label="Mines board, numbered left to right, top to bottom" data-testid="admin-mines-numbered-board">
        {Array.from({ length: 25 }, (_, tile) => {
          const bomb = bombs.has(tile);
          return <div key={tile} className={`admin-mines-board-tile ${bomb ? 'is-bomb' : 'is-diamond'}`} role="img" aria-label={`Tile ${tile + 1}: ${bomb ? 'mine' : 'diamond'}`} data-testid={`admin-mines-board-tile-${tile}`} data-tile={tile + 1} data-content={bomb ? 'mine' : 'diamond'}>
            <span className="admin-mines-tile-number" data-testid={`admin-mines-board-number-${tile}`}>{tile + 1}</span>
            {bomb ? <MinesBomb /> : <MinesDiamond />}
          </div>;
        })}
      </div>
    </DialogContent>
  </Dialog>;
};